import {ResourceType} from '@toolify/server/src/models/mongoose/PermissionModel/enum/ResourceType'

export const ResourceTypeColorMap = new Map<ResourceType, string>([
  [ResourceType.Workspace, '#8b93a7'],
  [ResourceType.Database, '#00a9fb'],
  [ResourceType.DatabaseView, '#00a9fb'],
  [ResourceType.DatabaseSlice, '#00a9fb'],
  [ResourceType.DatabaseProperty, '#00a9fb'],
  [ResourceType.DatabaseItem, '#00a9fb'],
  [ResourceType.Conversation, '#39ba63'],
  [ResourceType.DirectConversation, '#39ba63'],
  [ResourceType.CallRoom, '#00bfa2'],
  [ResourceType.Dashboard, '#5a76e3'],
  [ResourceType.DashboardItem, '#5a76e3'],
  [ResourceType.Folder, '#e88000'],
  [ResourceType.CloudItem, '#e88000'],
  [ResourceType.Automation, '#f56f5c'],
  [ResourceType.AutomationVersion, '#f56f5c'],
  [ResourceType.AutomationRun, '#f56f5c'],
  [ResourceType.App, '#e14eca'],
  [ResourceType.AppAutomation, '#f56f5c'],
  [ResourceType.Connection, '#6b9dff'],
  [ResourceType.ConnectionDefinition, '#6b9dff'],
  [ResourceType.WebhookListener, '#6b9dff'],
  [ResourceType.WebhookListenerDefinition, '#6b9dff'],
  [ResourceType.Cron, '#c98a18'],
  [ResourceType.Skill, '#8d6ce0'],
  [ResourceType.Agent, '#3d8ef0'],
  [ResourceType.Document, '#7c6af5'],
  [ResourceType.Whiteboard, '#e2a03f'],
  [ResourceType.ResourceGroup, '#8b93a7'],
  [ResourceType.ResourceSpace, '#8b93a7'],
  [ResourceType.ResourceItem, '#8b93a7'],
  [ResourceType.DynamicFieldDefinition, '#6b9dff'],
])
